module.exports = __webpack_public_path__ + "img/transaction-icon-light.f4c5cf09.svg";